import React from 'react';
import DesignGenerator from '../components/DesignGenerator';
import AdNativeBanner from '../components/AdNativeBanner';
import { useLanguage } from '../contexts/LanguageContext';

const NailDesignPage: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto mb-12 text-center">
          <h1 className="text-4xl font-bold mb-4">
            {t('nail.title')}
          </h1>
          <p className="text-xl text-gray-400">
            {t('nail.subtitle')}
          </p>
        </div>
        
        {/* Native Banner Ad */}
        <div className="max-w-5xl mx-auto mb-8">
          <AdNativeBanner />
        </div>
        
        {/* Design Generator */}
        <div className="max-w-5xl mx-auto">
          <DesignGenerator type="nail" />
        </div>
        
        {/* Info Cards */}
        <div className="max-w-5xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <h3 className="text-xl font-bold mb-4">{t('nail.styles.title')}</h3>
            <ul className="space-y-3 text-gray-300">
              <li>{t('nail.styles.french')}</li>
              <li>{t('nail.styles.ombre')}</li>
              <li>{t('nail.styles.gel')}</li>
              <li>{t('nail.styles.threeD')}</li>
              <li>{t('nail.styles.minimalist')}</li>
              <li>{t('nail.styles.rhinestone')}</li>
            </ul>
          </div>
          
          <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
            <h3 className="text-xl font-bold mb-4">{t('nail.tips.title')}</h3>
            <ol className="space-y-4 text-gray-300 list-decimal ml-5">
              <li>
                <span className="font-medium text-white">{t('nail.tips.shape.title')}</span>
                <p className="mt-1 text-gray-400">{t('nail.tips.shape.description')}</p>
              </li>
              <li>
                <span className="font-medium text-white">{t('nail.tips.color.title')}</span>
                <p className="mt-1 text-gray-400">{t('nail.tips.color.description')}</p>
              </li>
              <li>
                <span className="font-medium text-white">{t('nail.tips.seasonal.title')}</span>
                <p className="mt-1 text-gray-400">{t('nail.tips.seasonal.description')}</p>
              </li>
              <li>
                <span className="font-medium text-white">{t('nail.tips.professional.title')}</span>
                <p className="mt-1 text-gray-400">{t('nail.tips.professional.description')}</p>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NailDesignPage;